import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef, AfterViewInit, HostListener, ViewChildren, QueryList, Renderer2, Input, ChangeDetectorRef } from '@angular/core';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { Observable } from 'rxjs';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
@Component({
  selector: 'sidebar-section',
  templateUrl: './sidebar-section.component.html',
  styleUrls: ['./sidebar-section.component.scss']
})
export class SidebarSectionComponent implements OnInit, AfterViewInit {

  @ViewChild('header')
  public header: ElementRef;

  @ViewChildren('navigation')
  public navigations: QueryList<ElementRef>

  @Output()
  public headerHeightEmitter: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  public incrementSizeListener: EventEmitter<number> = new EventEmitter<number>();

  public tipoConsulta$: Observable<'proceso' | 'planeación' | 'administración'> = null;

  constructor(
    private renderer: Renderer2,
    private autenticacionService: AutenticacionService,
    private cd: ChangeDetectorRef,
    private facadeSesionService: FacadeSesionService
  ) { }

  ngOnInit() {
    this.tipoConsulta$ = this.facadeSesionService.usuarioEnSesionService.obtenerTipoConsulta();
  }

  public ngAfterViewInit(): void {
    this.cd.detectChanges();
    this.navigations.forEach(
      (navigation: ElementRef) => {
        this.renderer.listen(navigation.nativeElement, 'click', (event: any) => {
          this.incrementSizeListener.emit(parseInt((event.target as HTMLElement).dataset.incrementWidth));
        })
      }
    );
  }

  public cerrarSesion() {
    this.autenticacionService.cerrarSesion();
  }

  public imagenCargada(evt: any): void {
    if (evt && evt.target) {
      this.headerHeightEmitter.emit(this.header.nativeElement.clientHeight);
    }
  }

  public incrementWidthDashboard(): void {
    this.incrementSizeListener.emit();
  }


}
